import React from 'react';
import FacetedSearchMultiSlider from "./FacetedSearchMultiSlider";
import MobileFilterGroup from "./MobileFilters/MobileFilterGroup";
import FacetedSearchSlider from "./FacetedSearchSlider";
import {translate} from "../Services/translation";
import {useSelector} from "react-redux";

const FacetedSearchCompact = ({facetFilters, onFacetChange, onSubmitFilter, onClearFilter}) => {
    const {measurementType} = useSelector((state) => state.measurement);

    const measurementUnit = +measurementType === 1 ? "Imperial" : "Metric";
    
    return (
        <div>
            <ul className="faceted-search faceted-search--compact row">
                {facetFilters &&
                    facetFilters.map(
                        (group, groupIndex) => {
                            if (group.type === "SingleSlider") {
                                return <FacetedSearchSlider key={groupIndex} group={group}
                                                            isMobile={true}
                                                            onFacetChange={onFacetChange}/>
                            }

                            if(group.type === "MultiRangeSlider" && group.meta.measurementUnit !== measurementUnit) {
                                return null;
                            }
                            
                            if (group.type === "MultiRangeSlider") {
                                return <FacetedSearchMultiSlider key={groupIndex} group={group}
                                                                 isMobile={true}
                                                                 onFacetChange={onFacetChange}/>
                            }

                            return group.options &&
                                group.options.length > 0 && (
                                    <MobileFilterGroup
                                        key={`${group.label}-${groupIndex}`}
                                        onFacetChange={onFacetChange}
                                        group={group}/>)
                        }
                    )}
            </ul>

            <div className="mobile-modal__footer">
                <button className="button mobile-modal__footer-button"
                        onClick={() => onSubmitFilter()}>{translate('product.filter')}</button>
                <button className="button button--neutral mobile-modal__footer-button"
                        onClick={() => onClearFilter()}>{translate('product.resetfilters')}</button>
            </div>
        </div>
    );
};

export default FacetedSearchCompact;
